import { Form as FormComponent } from 'components/Form';
import styled, { gapSize } from 'theme';

export const SubHeader = styled.div`
  & > p {
    color: var(--ref-color-gray-70);
  }

  a {
    text-decoration: underline;
    font-weight: var(--sys-font-weight-semibold);
  }
`;

export const Divider = styled.span`
  display: block;
  height: 3px;

  margin-left: -1rem;
  margin-right: -1rem;
  margin-bottom: 1em;

  background-color: var(--ref-color-gray-10);
`;

export const InfoContainer = styled.span`
  & > p {
    margin-top: 0px;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: ${gapSize(2)};
`;

export const FormContainer = styled.div`
  & > strong {
    display: block;

    margin-top: 1rem;
    margin-bottom: 0.5rem;
  }
`;

export const Form = styled(FormComponent)`
  & button {
    width: auto;
  }

  .form-button {
    order: 1;
    button:first {
      order: 2;
    }
  }
`;
